import { render, staticRenderFns } from "./SignupArguments.vue?vue&type=template&id=0a8ce583&scoped=true"
import script from "./SignupArguments.js?vue&type=script&lang=js&external"
export * from "./SignupArguments.js?vue&type=script&lang=js&external"
import style0 from "./SignupArguments.scss?vue&type=style&index=0&id=0a8ce583&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8ce583",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default})
